// extracted by mini-css-extract-plugin
export var chatHtmlText = "_of-2";
export var chatLink = "_of-0";
export var chatText = "_of-1";